//borderColor: (theme) => console.log(theme),
const keyNames = {
  REUSABLE: "REUSABLE",
  apiErrors: "apiErrors",
  themeMode: "themeMode",
  apiMsg: "apiMsg",
  extra: "extra",
  isLoading: "isLoading",
  toastData: "toastData",
  isAuthenticated: "isAuthenticated",
  //End multiple
  forceLogOut: "forceLogOut",
  userData: "userData",
  registeredUserData: "registeredUserData",
  dashboardData: "dashboardData",
  venuesData: "venuesData",
  suitableVenuesData: "suitableVenuesData",
  vendorData: "vendorData",
  venuePlanningData:"venuePlanningData",
  crmData:"crmData",
  leadsData:"leadsData",
  estimatesData:"estimatesData",
  particularCrmData:"particularCrmData",
  uploadData: "uploadData",
  attendeesData: "attendeesData",
};
export default keyNames;